export default __webpack_public_path__ + "static/media/thumbs-up-icon.46f78f5a.svg";